import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import FeatherIcon from "feather-icons-react";
import { Link } from "react-router-dom";
import { fetchAllNewsWithAuthors } from "../../services/newsService";
import { BASE_URL_IMAGE } from "../../config/api";
import FormattedContent from "../../components/Common/FormattedContent";
import "./NewsCard.css";

const NewsView = () => {
  const [newsData, setNewsData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await fetchAllNewsWithAuthors();
        setNewsData(response);
      } catch (error) {
        console.error("Error fetching news:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchNews();
  }, []);

  const renderNewsCard = (news, isActive) => {
    const statusClass = isActive ? "evcard-active" : "evcard-inactive";
    return (
      <div className="col-sm-6 col-md-6 col-xl-4 mb-4" key={news.news_id}>
        <div className={`evcard ${statusClass}`}>
          <div className="evcard-img-wrapper">
            <img
              src={`${BASE_URL_IMAGE}/uploads/newsImages/${news.news_thumbnail}`}
              alt={news.news_title}
              className="evcard-img"
              onError={(e) => (e.target.src = "/assets/img/blog/blog-01.jpg")}
            />
            <div className="evcard-badges">
              <span className={`evcard-badge ${isActive ? "bg-success" : "bg-secondary"}`}>
                {isActive ? "ACTIVE" : "INACTIVE"}
              </span>
              <span className="evcard-badge bg-primary">{news.news_category}</span>
            </div>
          </div>

          <div className="evcard-content">
            <div className="evcard-author">
              <img
                src={`${BASE_URL_IMAGE}/uploads/userProfiles/${news.user_profile_img || "default.png"}`}
                alt="author"
                className="evcard-author-img"
                onError={(e) => (e.target.src = "/assets/img/profiles/avatar-12.jpg")}
              />
              <div className="ms-2">
                <h5 className="mb-0 fw-bold">{news.user_name}</h5>
                <small className="text-muted">{news.user_designation || "Contributor"}</small>
              </div>
              <div className="ms-auto text-muted d-flex align-items-center">
                <FeatherIcon icon="calendar" size={14} className="me-1" />
                {new Date(news.createdAt).toLocaleDateString("en-GB")}
              </div>
            </div>

            <h5 className="fw-bold mt-3 mb-2">{news.news_title}</h5>
            <p className="evcard-desc">
              <FormattedContent htmlContent={news.news_description} />
            </p>

            <div className="evcard-footer">
              <div>
                <div className="fw-semibold">{news.news_tags || "No Tags"}</div>
                <div className="text-muted">{news.news_mode || "General"}</div>
              </div>
              <div className="d-flex gap-2">
                <Link to={`/news-detail/${news.news_id}`} className="btn btn-sm btn-view">View</Link>
                <Link to={`/edit-news/${news.news_id}`} className="btn btn-sm btn-edit">Edit</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const activeNews = newsData.filter((n) => n.news_status === 1);
  const inactiveNews = newsData.filter((n) => n.news_status !== 1);

  return (
    <div className="main-wrapper">
      <Header />
      <Sidebar id="menu-item11" id1="menu-items11" activeClassName="blog-grid" />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item"><Link to="/news-view">News</Link></li>
                  <li className="breadcrumb-item active">All News</li>
                </ul>
              </div>
            </div>
          </div>

          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <div className="row">
              {activeNews.length > 0 && (
                <div className="col-12 mb-4">
                  <h4 className="text-success fw-bold mb-3">
                    <FeatherIcon icon="check-circle" className="me-2" />
                    Active News ({activeNews.length})
                  </h4>
                  <div className="row">{activeNews.map((news) => renderNewsCard(news, true))}</div>
                </div>
              )}

              {inactiveNews.length > 0 && (
                <div className="col-12 mt-5">
                  <h4 className="text-muted fw-bold mb-3">
                    <FeatherIcon icon="slash" className="me-2" />
                    Inactive News ({inactiveNews.length})
                  </h4>
                  <div className="row">{inactiveNews.map((news) => renderNewsCard(news, false))}</div>
                </div>
              )}

              {newsData.length === 0 && (
                <div className="text-center py-5">
                  <h5>No news found.</h5>
                  <Link to="/add-news" className="btn btn-primary mt-3">Add News</Link>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NewsView;
